import { Fragment, useMemo } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { Small } from 'foundations-components/transitional/components/Small';
import PageOneLink from './PageOneLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ResultsCount = ({
  activePage,
  filtersHeadingI18nKey,
  hasResults,
  offset,
  resultsLength,
  resultsTotal,
  searchValue
}) => {
  const {
    start,
    end,
    total
  } = useMemo(() => ({
    start: resultsTotal ? offset + 1 : 0,
    end: Math.min(offset + resultsLength, resultsTotal),
    total: Math.max(resultsTotal, resultsLength)
  }), [offset, resultsLength, resultsTotal]);
  if (!hasResults) {
    return null;
  }
  const renderedCount = /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "appMarketplace.storefront.results.resultsPage.resultsCount",
      options: {
        start,
        end,
        total
      }
    }), ' ', searchValue && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "appMarketplace.storefront.results.resultsPage.resultsCountSearchText",
      options: {
        searchValue,
        pageHeading: unescapedText(filtersHeadingI18nKey)
      }
    })]
  });
  if (searchValue && !hasResults) {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [renderedCount, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Small, {
        "data-test-id": "results-count-search-title",
        children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "appMarketplace.storefront.results.resultsPage.noResultsEmptyState.searchTitle_jsx",
          elements: {
            b: 'b'
          },
          options: {
            searchValue,
            pageHeading: unescapedText(filtersHeadingI18nKey)
          }
        }), activePage > 1 && /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(PageOneLink, {})
        })]
      })]
    });
  }
  return renderedCount;
};
export default ResultsCount;